import Chart from "react-apexcharts";
import { colors } from "../../GlobalDashboardPage";

export interface IStackedBarChartProps {
  series: { name: string; data: number[] }[];
  categories: string[];
}

const StackedBarChart = ({ series, categories }: IStackedBarChartProps) => {
  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'all',
        columnWidth: "80%",
        dataLabels: {
          total: {
            enabled: true,
            offsetY: -5,
            style: {
              fontSize: '14px',
              fontWeight: 600
            }
          }
        }
      },
    },
    grid: {
      show: false,
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    colors: Object.values(colors),
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={"90%"}
    />
  );
};

export default StackedBarChart;
